import { Grid, InputAdornment } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IForm from '../../../components/i-form/i-form.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import INumberField from '../../../components/text-component/numberfield/i-numberfield.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import LinkIcon from '@mui/icons-material/Link';
import { CREATE_MODE, EDIT_MODE, EMPTY_STRING, GET_ALL_SUPPLIER_URL, 
         INPUT_SELECT_ITEMS, LABOR_INPUT, TYPE_LABOR, TYPE_MATERIAL, TYPE_PROCESS } from '../../common/constants';
import { getSpecUrl, isChecking, isEmpty, isNotNull, isPacking } from '../../common/util.services';
import { getMasterDataById, saveMasterData } from '../masterdata.services';
import { LABOR_SPECS_MAP, MATERIAL_SPECS_MAP, PROCESS_SPECS_MAP, SpecListItem } from '../specs/specs.mapping';
import ICheckbox from '../../../components/checkbox/i-checkbox.component';
import { INPUT_UOM_MAP } from '../input-uom';
import { Visibility } from '@mui/icons-material';

const MasterDataForm = () => {
  const appContext = useContext(AppContext);
  const [title, setTitle] = useState<string>('Add Input Data');
  const [type, setType] = useState<string>(EMPTY_STRING);
  const [input, setInput] = useState<string>(EMPTY_STRING);
  const [spec1, setSpec1] = useState<string>(EMPTY_STRING);
  const [isNewVersion, setIsNewVersion] = useState<boolean>(false);
  const [specList, setSpecList] = useState<any>([]);
  const [masterData, setMasterData] = useState<any>({processLossPercentage: 0, currency: 'Rs.'});
  const navigate = useNavigate();
  const [inputList, setInputList] = useState<string[]>([]);
  const [inputUOM, setInputUOM] = useState<string[]>([]);
  const materialInputList: string[] = Object.keys(MATERIAL_SPECS_MAP).sort();
  const processInputList: string[] = Object.keys(PROCESS_SPECS_MAP).sort();
  const laborInputList: string[] = LABOR_INPUT.sort();
  const [mode, setMode] = useState<string>(CREATE_MODE);
  const [loader, setLoader] = useState(true);
  const params = useParams()
  const rowId = params.rowId;
  const [details, setDetails] = useState('');
  const {state} = useLocation();
  const {isCopy} = state || {};
  const quoteLink = "https://drive.google.com/drive/folders/107HNy6xe6o11HoISBcsLpz2SAYL4n_r2";

  useEffect(() => {
    if (isNotNull(rowId)) {
      setIsNewVersion(true);
      setMode(EDIT_MODE);
      getMasterDataById(rowId, appContext,
        (response: any) => {
          setDetails(response.data.quoteLink);
          setTitle(isCopy ? 'Copy Input Data' : 'Edit Input Data');
          setMasterData(response.data);
          updateInputType(response.data.type);
          setInput(response.data.input)
          setSpec1(response.data.spec1);
          updateSpecType(response.data.type, response.data.input);
          setInputUOM(INPUT_UOM_MAP[response.data.input].sort());
          appContext.setShowLoader(false);
          setLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  }, []);

  const onSubmit = (data: any) => {
    data.isNewVersion = isNewVersion ? 1 : 0;
    data.isCopy = isCopy;
    saveMasterData(data, appContext,
      (response: any) => {
        navigate('/master-data/list');
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  }

  const onTypeChange = (e: any) => {
    const type = e.target.value;
    updateInputType(type);
  }

  const updateInputType = (type: any) => {
    setType(type);
    setSpecList([]);
    if (type === TYPE_MATERIAL) {
      setInputList(materialInputList);
    } else if (type === TYPE_PROCESS) {
      setInputList(processInputList);
    } else if (type === TYPE_LABOR) {
      setInputList(laborInputList);
    }
  }

  const onInputChange = (e: any) => {
    const input = e.target.value;
    setInput(input);
    updateSpecType(type, input);
    setInputUOM(INPUT_UOM_MAP[input].sort());
  }

  const onChangeEvent = (e: any) => {
    const value = e.target.checked;
    setIsNewVersion(value);
  }

  const updateSpecType = (type: string, input: string) => {
    if (type === TYPE_MATERIAL) {
      setSpecList(MATERIAL_SPECS_MAP[input]);
    } else if (type === TYPE_PROCESS) {
      setSpecList(PROCESS_SPECS_MAP[input]);
    } else if (type === TYPE_LABOR) {
      if(isChecking(input)) {
        setSpecList(LABOR_SPECS_MAP['Checking']);
      } else if(isPacking(input)) {
        setSpecList(LABOR_SPECS_MAP['Packing']);
      } else {
        setSpecList(LABOR_SPECS_MAP['Bale Packing']);
      }
    }
  }

  const getMainComponent = () => {
    return <Grid container spacing={1}>
      <Grid xs={3}>
        <IDropdown name='type' label='Type' itemList={INPUT_SELECT_ITEMS}
          onChangeEvent={(e: any) => onTypeChange(e)} required={true} disabled={isNotNull(rowId)} />
      </Grid>
      <Grid xs={3}>
        <IDropdown name='input' label='Input' itemList={inputList} onChangeEvent={(e: any) => onInputChange(e)}
          disabled={isNotNull(rowId)} required={true} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='description' label='Description' required={true} disabled={false}/>
      </Grid>
      {specList.map((spec: SpecListItem) => {
        return <Grid xs={3}>
          {spec.type === "select" ? <IDropdown name={spec.fieldObject} label={spec.fieldName} 
            itemList={spec.items.sort()} url={getSpecUrl(input, spec)}
            onChangeEvent={(e: any) => (setSpec1(e.target.value))} required={true} disabled={isNotNull(rowId) && !isCopy}/> :
           spec.type === 'number' ? <INumberField name={spec.fieldObject} label={spec.fieldName} 
                                      required={true} disabled={isNotNull(rowId) && !isCopy}/> :
           <ITextField name={spec.fieldObject} label={spec.fieldName} required={true} disabled={isNotNull(rowId) && !isCopy} />}
        </Grid>
      })}
      <Grid xs={3}>
        <ITextField name='sku' label='SKU' required={true} disabled={false} />
      </Grid>
      <Grid xs={3}>
        <IDropdown name='uom' label='UOM' itemList={inputUOM} required={true} disabled={isNotNull(rowId) && !isCopy} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='currency' label='Currency' required={true} disabled={true} />
      </Grid>
      <Grid xs={3}>
        <INumberField name='unitCost' label='Unit Cost' required={!('Embroidery' === input && 'Manual' === spec1)} />
      </Grid>
      <Grid xs={3}>
        <IDropdown name='supplier' label='Supplier' required={true} url={GET_ALL_SUPPLIER_URL} disabled={isNotNull(rowId) && !isCopy}/>
      </Grid>
      <Grid xs={1.5}>
        <ITextField name='moq' label='MOQ' required={true} disabled={isNotNull(rowId) && !isCopy}/>
      </Grid>
      <Grid xs={1.5}>
        <INumberField name='processLossPercentage' label='Process Loss (%)' 
          required={true} disabled={(isNotNull(rowId) && !isCopy) || type === TYPE_MATERIAL || isEmpty(type)} />
      </Grid>
      <Grid xs={3}>
        <ITextField name='quoteLink' label='Quote Link' required={true}
         InputProps={{startAdornment: (<InputAdornment position="start"> <Link to={quoteLink} target="_blank"> <LinkIcon/> </Link></InputAdornment>),
                      endAdornment: (<InputAdornment position="end"> <Link to={details} target="_blank"> <Visibility/> </Link> </InputAdornment>)}}/>
      </Grid>
      <Grid xs={3}>
        <ITextField name='remarks' label='Remarks' required={true}/>
      </Grid>
      {mode !== CREATE_MODE && !isCopy && <Grid xs={3}>
        <ICheckbox name='isNewVersion' label='Cost Revision' required={true} onChangeEvent={onChangeEvent} defaultChecked={true}/>
      </Grid>}
    </Grid>
  }

  return loader ? <></> : <IForm formData={masterData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default MasterDataForm;